import parse from "html-react-parser";
import type { FC, ReactNode } from "react";

import { cn } from "../../utils";
import { sanitizeMessageHtml } from "../email-draft/sanitize-html";
import { ShadowHost } from "../shadow-host";

export interface MessageHtmlProps {
  html?: ReactNode;
  text?: string | null;
  className?: string;
  /**
   * Compiled CSS for the email body, scoped to its shadow root. It's a prop because the sheet is
   * Tailwind source that only an app's Vite pipeline can compile (`shadow-dom.css?inline`), and
   * that bundler-specific import must stay out of the shared barrel.
   */
  shadowStyles: string;
}

export const MessageHtml: FC<MessageHtmlProps> = ({ className, html, shadowStyles, text }) => {
  if (html) {
    const content = typeof html === "string" ? parse(sanitizeMessageHtml(html)) : html;

    return (
      <div className="@container/message-html">
        <div className={cn("dark:bg-white dark:rounded dark:p-4 overflow-x-auto", className)}>
          {/* IMPORTANT: The relative position is necessary to ensure absolutely positioned elements
        in the email body are positioned correctly and don't break the application layout */}
          <ShadowHost className="prose dark:text-black relative isolate">
            <style type="text/css">{shadowStyles}</style>
            {content}
          </ShadowHost>
        </div>
      </div>
    );
  }

  if (text) {
    return <div className="whitespace-pre-wrap">{text}</div>;
  }

  return null;
};
